/* istanbul ignore file */
export { default } from './PhotoFeatureCard';
